import styled from '../../config/theme'

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: ${props => props.theme.color.bluishGray};
  padding: 50px calc((100vw - ${props => props.theme.mediaQueries.layout}) / 2);

  @media screen and (max-width: ${props => props.theme.mediaQueries.layout}) {
    padding: 50px calc((100vw - ${props => props.theme.mediaQueries.layoutMobile}) / 2);

    flex-direction: column;

    > * {
      margin: 30px 0;
    }
  }
`

const Links = styled.ul`
  list-style: none;
  padding-inline-start: 0;
  margin: 0;
`

const Link = styled.li`
  margin: 10px 0;

  > a {
    color: ${props => props.theme.color.white};
    text-decoration: none;
  }
`

const Apps = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;

  > * {
    margin: 10px;
  }

  > * {
    margin: 10px 5px;
  }

  > button {
    height: 48px;
  }
`

const Social = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;

  > * {
    margin: 10px;
  }
`

const Copyright = styled.div`
  height: 72px;
  width: 100%;
  background: ${props => props.theme.color.lightBluishGray};
  display: flex;
  justify-content: center;
  align-items: center;
`

export {
  Container,
  Links,
  Link,
  Apps,
  Social,
  Copyright,
}
